import { render, staticRenderFns } from "./side-nav-franchise.vue?vue&type=template&id=d69dde1a&scoped=true"
import script from "./side-nav-franchise.vue?vue&type=script&lang=js"
export * from "./side-nav-franchise.vue?vue&type=script&lang=js"
import style0 from "./side-nav-franchise.vue?vue&type=style&index=0&id=d69dde1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69dde1a",
  null
  
)

export default component.exports